export { type LatestWebhookDefinition as WebhookDefinition } from "../orpc-client/api/contract-latest.js";
